module.exports = __webpack_public_path__ + "static/img/22.ad2a56e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/22.jpeg
// module id = S3+C
// module chunks = 1